<div class="modal-body">
  <div class="modal-heading">
    <h2 class="modal-title">Filters - DP 1.0</h2>
    <div class="close-button" (click)="close()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>

  <div class="filter-body">
    <div class="filter-left-pannel">
      @for (flt of filters; track $index) {
      <button
        class="filter-option"
        [ngClass]="{ 'selected-filter': $index === selectedFilterIndex }"
        (click)="selectedFilterIndex = $index"
      >
        {{ flt }}
      </button>
      }
    </div>
    <div class="line"></div>

    <div class="filter-right-pannel">
      @if (selectedFilterIndex === 0) {
      <input
        type="text"
        class="dp-input-control searchInput"
        placeholder="Enter address"
        [formControl]="address"
      />
      } @if (selectedFilterIndex === 1) {
      <input
        type="text"
        class="dp-input-control searchInput"
        placeholder="Enter state"
        [(ngModel)]="state"
        (input)="onEnterState($event)"
      />
      <div
        class="filter-right-pannel"
        style="max-height: 200px; overflow-y: auto"
      >
        @for (st of filteredStateList; track $index) {
        <div class="state-filter-option" (click)="onSelectState($index)">
          <div
            class="checkbox"
            [ngClass]="{ 'checkbox-checked': $index === selectedStateIndex }"
          ></div>
          <div
            class="state-filter-text"
            [ngStyle]="{
              color: $index === selectedStateIndex ? 'var(--text-primary)' : ''
            }"
          >
            {{ st }}
          </div>
        </div>
        }
      </div>
      } @if (selectedFilterIndex === 2) {
      <input
        type="text"
        class="dp-input-control searchInput"
        placeholder="Enter district"
        [(ngModel)]="district"
        (input)="onEnterDistrict($event)"
      />
      <div
        class="filter-right-pannel"
        style="max-height: 200px; overflow-y: auto"
      >
        @for (dt of filteredDistrictList; track $index) {
        <div class="state-filter-option" (click)="onSelectDistrict($index)">
          <div
            class="checkbox"
            [ngClass]="{ 'checkbox-checked': $index === selectedDistrictIndex }"
          ></div>
          <div
            class="state-filter-text"
            [ngStyle]="{
              color:
                $index === selectedDistrictIndex ? 'var(--text-primary)' : ''
            }"
          >
            {{ dt }}
          </div>
        </div>
        }
      </div>
      @if (this.selectedStateIndex < 0 || this.selectedStateIndex === undefined)
      {
      <span style="color: var(--brand-destructive)">Select state first</span>
      } }
    </div>
  </div>

  <div class="button-section">
    <button
      class="dp-secondary-btn"
      style="width: 100%; height: 40px"
      (click)="resetFilter()"
    >
      Reset filters
    </button>
    <button
      class="dp-primary-btn"
      style="width: 100%; height: 40px"
      (click)="onApplyFilter()"
    >
      Apply changes
    </button>
  </div>
</div>
